import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUserData } from '../interfaces/IUserData';

const initialState :IUserData={
    loginData: null,
}

export const userDataSlice = createSlice({
  name: 'userData',
  initialState,
  reducers: { 
    storeUserData: (state=initialState, action: PayloadAction<IUserData>) => {  
      state.loginData = action?.payload.loginData;
    },
    logoutUser: (state) => {
      state.loginData = null;
    },
  },
});

export const { storeUserData, logoutUser } = userDataSlice.actions;
export const selectAccessToken = (state:any) => state?.userData?.loginData?.accessToken;
export default userDataSlice.reducer;